module.exports = __webpack_public_path__ + "fonts/Calibre-LightItalic.f34c1430.woff2";